import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import * as React from "react";
import { Route, Routes } from "react-router-dom";
import CreateSeason from "./CreateSeason";
import SeasonProfile from "./SeasonProfile";

const plus = <FontAwesomeIcon icon={["fad", "plus"]}></FontAwesomeIcon>;
const edit = <FontAwesomeIcon icon={["fad", "pencil"]}></FontAwesomeIcon>;
const idBadge = <FontAwesomeIcon icon={["fad", "id-badge"]}></FontAwesomeIcon>;

const SeasonsManagement = () => {
    return (
        <div>
            <Routes>
                <Route path={"create/:leagueID"} element={<CreateSeason />}></Route>
                <Route path={":seasonID/*"} element={<SeasonProfile />}></Route>
            </Routes>
        </div>
    );
};

export default SeasonsManagement;
